import { lazy } from "react";
import { Role, QUESTIONNAIRE_ROLES } from "@/components/Access/Role";
import { PluginManifest } from "../types";
import HeadacheQuestionnairesCard from "./HeadacheQuestionnairesCard";

// Page components stay lazy (as they were in the host routers); the host route
// trees render module routes inside their existing <Suspense> boundary.
const QuestionnaireReview = lazy(() => import("./QuestionnaireReview"));
const PatientQuestionnaire = lazy(() => import("./PatientQuestionnaire"));

/**
 * The headache-questionnaire module (TeleHeadache). Contributes the clinical
 * "Headache Questionnaires" dashboard card and the questionnaire review +
 * patient questionnaire routes. Enabled by default for the `th` brand only.
 */
export const headacheQuestionnaireModule: PluginManifest = {
  id: "headache-questionnaire",
  dashboardCards: [
    {
      id: "headache-questionnaires",
      audience: "clinical",
      roles: [Role.MtcDoc],
      render: () => <HeadacheQuestionnairesCard />,
    },
  ],
  routes: [
    {
      path: "/questionnaire-review",
      audience: "clinical",
      // Q3.3: the review queue and its submit are for the questionnaire roles; a nurse would only
      // meet 403s here.
      roles: QUESTIONNAIRE_ROLES,
      element: <QuestionnaireReview />,
    },
    {
      path: "/questionnaire/:questionnaireId",
      audience: "patient",
      roles: [Role.Patient],
      element: <PatientQuestionnaire />,
    },
  ],
};
